const name = 'yes-data-object';
import { createName, dataSource } from '../../utils';
export default {
    icon: "yes-icon-data-object",
    label: '数据对象',
    name,
    drag: true,
    dragBtn: true,
    inside: true,
    mask: false,
    rule() {
        return {
            type: name,
            props: {
                dataSource: ''
            },
            children: []
        };
    },
    props() {
        return [
            createName(),
            dataSource()
        ]
    }
};
